// @flow

import { useTranslator } from '@gandi/translate';
import { Base, Heading } from '@gandi/ui';

export function DurationRowMultiyearPromo({
  percent,
  promoMinDuration,
}: {
  percent: number,
  promoMinDuration: number,
}): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Base flexAlignSelfStart>
      <Heading as="h4" fontSize="xs" color="promotional">
        {__('Your loyalty rewarded')}
      </Heading>
      <Base tagName="p" margin="none" size="small">
        {__('Choose %(years)s years or more and save %(percent)s%%', {
          years: promoMinDuration,
          percent,
        })}
      </Base>
    </Base>
  );
}
